import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

export const SignatureIcon = ({ className, style }: SvgIconProps) => (
  <Icon
    icon="signature"
    className={className}
    style={{ width: '1em', height: '1em', ...style }}
  />
);
